module.exports = __webpack_public_path__ + "img/12.b1692178.jpg";